// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__YKGyG","footerWrapper":"footer_footerWrapper__goO-D","getHelp":"footer_getHelp__PnYdi","sayHi":"footer_sayHi__LwGZh"};